
import router from './router'
import store from './store'
import getPageTitle from '@/utils/get-page-title'
import { getToken } from './utils/auth'
// import routerModules from '@/router/router-modules'

let isLoad = false
const whiteList = ['/binding','/wxLogin','/newWXLogin','/newIndex2',
                           '/user/orders','/appDiscountCoupon','/appAppraise',
                           '/sampleImage','/sampleImages','/si','/videoViewing',
                           '/Zip','/applySubAccount'] // no redirect whitelist

// 开发版
// function generateRoles(data) {
//   const roles = []
//   for (let i = 0; i < data.length; i++) {
//     roles.push(data[i].meta.roles[0])
//     if (data[i] instanceof Object && Object.hasOwnProperty.call(data[i], 'children')) {
//       roles.push(...generateRoles(data[i].children))
//     }
//   }
//   return roles
// }

router.beforeEach(async(to, from, next) => {
  console.log(getToken())
    // start progress bar

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user h as logged in
  const hasToken = getToken()

  if (hasToken) {
    if ( to.path === '/wxLogin' || to.path === '/binding' || to.name === 'user-orders'
      || to.path === '/appDiscountCoupon' || to.path === '/appAppraise' || to.path === '/sampleImage'
      || to.path === '/sampleImages'|| to.path === '/si' || to.path === '/videoViewing'
      || to.path === '/Zip'|| to.path === '/newWXLogin'|| to.name === 'new-index2'
      || to.path === '/applySubAccount'
    )
    {
      // if is logged in, redirect to the home page
      next()
    } else {
      try {
        if (!isLoad) {
          // const roles = getRoleKey(userInfo.roles, [])
          // const roles = generateRoles(routerModules)
          store.commit('user/SET_ROLES', [])
          // store.commit('user/SET_USERINFO', userInfo)
          const accessRoutes = await store.dispatch('permission/generateRoutes', [])
          router.addRoutes(accessRoutes)
          // next({ ...to, replace: true })
        }
        isLoad = true
        next()
      } catch (error) {
        // remove token and go to login page to re-login
        await store.dispatch('user/resetToken')
        next(`/wxLogin`)
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1 || to.name == 'user-orders') {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      sessionStorage.setItem('returnTo', window.location.href);
      next(`/wxLogin`)
    }
  }
})

router.afterEach(() => {
  // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js